import EventEmitter from "events";

export default class Test extends EventEmitter {
  constructor(api, name = "Unnamed Test") {
    super(); // Initialize EventEmitter
    this.reset();
    this.api = api;
    this.name = name;
  }
  reset() {
    this.status = "not started";
    this.message = "Test has not started yet.";
    this.totalTests = 0;
    this.passedTests = 0;
    this.failedTests = 0; // Tracks failed tests
    this.completedTests = 0; // Tracks completed tests
    this.progress = 0;
    this.tests = []; // Array of individual tests
  }

  async run() {
    try {
      this.update({
        status: "running",
        message: "Initializing tests..."
      });

      // Initialize tests using the init method (to be implemented in subclasses)
      this.tests = (await this.init()) || [];
      this.totalTests = this.tests.length;

      if (this.totalTests === 0) {
        throw new Error("No tests to execute.");
      }

      this.update({ progress: 10, message: "Executing tests..." });

      // Execute each test in sequence
      for (let i = 0; i < this.tests.length; i++) {
        const test = this.tests[i];
        const currentProgress = 10 + ((i + 1) / this.totalTests) * 90;

        const result = await this.exec(test);
        test.result = result; // Store result in test object
        this.update({
          message: result.message,
          progress: currentProgress,
          completedTests: this.completedTests + 1,
          passedTests: this.passedTests + (result.success ? 1 : 0),
          failedTests: this.failedTests + (result.success ? 0 : 1),
          tests: this.tests
        }); // Emit update after each test
      }

      // Final status
      const status = this.failedTests === 0 ? "success" : "warning";
      const finalMessage = `${this.completedTests} of ${this.totalTests} tests completed. ${this.passedTests} passed, ${this.failedTests} failed.`;

      this.update({ status, message: finalMessage, progress: 100 });
    } catch (error) {
      this.update({
        status: "error",
        message: `Test failed: ${error.message}`,
        progress: 100
      });
      console.error(`Error in ${this.name}:`, error);
    }
  }

  /**
   * Updates the test properties and emits an update event.
   * @param {Object} updates - Key-value pairs to update.
   */
  update(updates) {
    for (const key in updates) {
      if (updates.hasOwnProperty(key)) {
        this[key] = updates[key];
      }
    }
    this.emit("update", this); // Emit update event
  }

  async init() {
    throw new Error("Init method must be implemented in subclass.");
  }

  // eslint-disable-next-line no-unused-vars
  async exec(test) {
    throw new Error("Exec method must be implemented in subclass.");
  }
}
